<script>
    import { setContext, getContext, createEventDispatcher } from 'svelte'
    import { writable } from 'svelte/store'
    import { MapStore } from './map-store'
    import ReportTabs from './report/ReportTabs.svelte'

    const readyStore = getContext('readyStore') || writable(new Map())
    const printing = getContext('printStore') || writable(false)

    setContext('printStore', printing)
    setContext('readyStore', readyStore)

    const ANB_STORE = 'Section.activeNotebookStore';
    setContext(ANB_STORE, getContext(ANB_STORE) || new MapStore());

    export let header = null
    export let categories
    export let isTopicPickerEnabled = false
    export let alwaysShowCategoryTabs = false

    $: headerArgs = {
        ...header,
        showHeader: (header && header.showHeader || false)
    }

    let activeCategoryIdx = 0

    const dispatch = createEventDispatcher()

    let doShowTopicPicker = () => {
        console.log('showTopicPicker')
        dispatch('showTopicPicker')
    }

    $: activeCategories = $printing ? categories : [categories[activeCategoryIdx]].filter(cat => !!cat)

    function showTopicHeader (category, topic) {
        if (topic.showHeader) {
            return true
        }

        return category.title !== topic.title
    }

    // $: activeTopics = $printing ? categories.map(cat => cat.topics).reduce((acc, ts) => acc.concat(ts), []) : (activeCategory && activeCategory.topics || [])
</script>

<style>
    .report-category-tabs {
        margin-top: 1em;
    }

    .add-layers-button {
        float: right;
    }

    .report-category-tabs:after {
        content: "";
        display: table;
        clear: both;
    }

    @media screen {
        :global(.print-only) {
            display: none;
        }
    }

    .category-title {
        page-break-after: avoid;
        break-after: avoid-page;
        color: #6e7676;
    }

    .report-content {
        padding: 0 1em;
    }

    @media print {
        .report-content {
            padding: 0;
        }
    }
</style>

<slot name="toolbar">

</slot>

<div class="report-container">
    <slot name="header" header={header} printing={$printing}></slot>

    <div class="report-content">
        {#if !$printing}
            <div class="report-category-tabs no-print">
                {#if isTopicPickerEnabled}
                    <button class="btn-rounded bg-frag-inverse add-layers-button"
                            on:click={doShowTopicPicker}>Add/remove layers
                    </button>
                {/if}

                {#if categories.length > 1 || alwaysShowCategoryTabs }
                    <ReportTabs {categories} bind:activeCategoryIdx></ReportTabs>
                {/if}
            </div>
        {/if}

        {#each activeCategories as category}
            <h2 class="category-title print-only">{category.title}</h2>
            {#each category.topics as topic (topic.id)}
                <slot name="topic" {topic} {category} printing={$printing}></slot>
            {/each}
        {/each}

        <slot name="footer" printing={$printing}></slot>
    </div>
</div>
